import { useStore } from '../../app'
import { acquireTokenSilent, MsalContextValue } from "../../MsalContextProvider";

export interface IFetchBlobArgs {
    id: string,
    fileName: string
}

const fetchBlob = async (fetchBlobArgs: IFetchBlobArgs, msalContext: MsalContextValue) => {
    return await invokeFetchDownload('GET', `/api/abp/bericht/files/${fetchBlobArgs.id}`, fetchBlobArgs.fileName, msalContext);
};

const invokeFetchDownload = async (
    method: 'GET',
    uri: string,
    fileName: string,
    msalContext: MsalContextValue,
): Promise<any> => {

    const {apiEndpoint, apiScopes} = useStore.getState().configuration
    const endpoint = `${apiEndpoint}${uri}`;    

    const token = await acquireTokenSilent(
        msalContext.instance,
        apiScopes
    );
    const resp = await fetch(endpoint, {
        method: method,
        headers: {
            Authorization: `Bearer ${token}`
        },
    });

    if (resp.status === 204) return {} as any;

    if (resp.ok) {
        // download the file
        const blob = await resp.blob();
        const blobURL = URL.createObjectURL(blob);
        const el = document.createElement('a');
        el.href = blobURL;
        if (fileName) {
            // fileName has standard the extension .xml
            // If blob.type (mime type) is not xml, then we need to change the extension
            // to the mime type extension, text/html -> .html
            if (!blob.type.includes('.xml')) {
                // We only try to add the proper extension for the most common mime types
                var mimeExtension = '';
                switch (blob.type) {
                    case 'text/html':
                        mimeExtension = '.html';
                        break;
                    case 'text/plain':
                        mimeExtension = '.txt';
                        break;
                    case 'application/pdf':
                        mimeExtension = '.pdf';
                        break;
                    case 'application/json':
                        mimeExtension = '.json';
                        break;
                }
                fileName = fileName + mimeExtension;
            }
            el.download = fileName
        }
        document.body.appendChild(el);
        el.click();
        return {} as any;

    } else if (resp.status === 404) {
        useStore.setState({
            genericError: {
                title: 'Dit record is niet beschikbaar',
                subText:
                    'Het gevraagde record is niet gevonden of u beschikt niet over de juiste machtigingen om deze weer te geven.'
            }
        })
    } else if (resp.status === 500) {
        useStore.setState({
            genericError: {
                title: 'Internal server error',
                subText: '',
            }
        })
    } else {
        useStore.setState({
            genericError: {
                title: 'Unknown server error',
                subText: '',
            }
        })
    }
    return Promise.reject();
};

export { fetchBlob }